export default __webpack_public_path__ + "static/media/waavo.467359d7.png";